import { Flex, VStack, Box, InlineBanner, Text } from '@cad-arc';
import { LoadingIndicator } from '../../../common/components/loading-indicator';
import { useIntegratedForm } from '../../../forms/use-integrated-form';
import { useSearchUnitHistoryResponse } from '../../context/hooks';
import { useIsUnitHistorySearchEmpty } from '../../hooks/use-is-unit-history-search-empty';
import { UnitHistoryForm } from '../../types';
import { UnitHistoryResults } from './unit-history-results';

export function UnitHistoryRightPane({
    resultsScrollElementRef,
}: {
    resultsScrollElementRef: React.RefObject<HTMLDivElement>;
}): React.ReactElement {
    return (
        <Box bgColor="surface.canvas" w="100%" h="100%" padding="16px" overflowY="auto">
            <UnitHistoryRightPaneBody resultsScrollElementRef={resultsScrollElementRef} />
        </Box>
    );
}

function UnitHistoryRightPaneBody({
    resultsScrollElementRef,
}: {
    resultsScrollElementRef: React.RefObject<HTMLDivElement>;
}): React.ReactElement {
    const searchUnitHistoryResponse = useSearchUnitHistoryResponse();
    const unitHistoryItemsGroups = searchUnitHistoryResponse?.unitHistoryItemsGroups ?? [];
    const { form, mutation } = useIntegratedForm<UnitHistoryForm>();
    const isSearchEmpty = useIsUnitHistorySearchEmpty();
    if (mutation.isError) {
        return (
            <InlineBanner
                status="error"
                title="An error occurred while loading unit history"
                actions={[{ children: 'Retry', onClick: () => mutation.mutate(form.getValues()) }]}
            />
        );
    }
    if (mutation.isLoading) {
        return <LoadingIndicator />;
    }
    if (isSearchEmpty) {
        return (
            <Flex h="100%" w="100%" justifyContent="center" alignItems="center">
                <VStack>
                    <Text variant="headingXs">No Results</Text>
                    <Text variant="bodyMd">Search to get started</Text>
                </VStack>
            </Flex>
        );
    }
    if (unitHistoryItemsGroups.length === 0) {
        return (
            <Flex h="100%" w="100%" justifyContent="center" alignItems="center">
                <Text variant="headingXs">No Results</Text>
            </Flex>
        );
    }
    return (
        <UnitHistoryResults
            unitHistoryItemsGroups={unitHistoryItemsGroups}
            scrollElementRef={resultsScrollElementRef}
        />
    );
}
